import React, { useEffect, useMemo, useState } from "react";
import { Box } from "@material-ui/core";
import { GetAgentsCourseQualifications } from "../../../../../../Services";
import { useVerticalNav } from "../../../../../../Contexts/VerticalNavContext";
import { AgentCard, FilterSectionAgentCourseQualifications } from "./UI";
import {
  AgentCardSkeleton,
  CustomPagination,
  NoDataFound,
} from "../../../../../../Components";
import { useTranslate } from "../../../../../../Hooks";

//  styles
import useStyles from "./styles";

const initialFilter = {
  lmsCourseId: null,
  agentName: null,
  branchId: null,
  teamId: null,
  staffCode: null,
  badgeFilter: null,
};

function AgentCourseQualifications({ propretyId, unitId }) {
  const styles = useStyles();
  const { setAlertBoxContent } = useVerticalNav();
  const { translate } = useTranslate("NewPropertiesView");
  const [agents, setAgents] = useState({ result: [], totalCount: 50 });
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ pageIndex: 1, pageSize: 25 });
  const [filter, setFilter] = useState(initialFilter);
  const [inputValue, setInputValue] = useState(pagination.pageIndex);
  const [message, setMessage] = useState(null);

  const idObject = useMemo(() => {
    if (unitId) {
      return { unitId };
    } else {
      return { propertyId: Number(propretyId) };
    }
  }, []);

  const getAgentsCourseQualifications = async () => {
    setLoading(true);
    try {
      const response = await GetAgentsCourseQualifications({
        ...idObject,
        ...pagination,
        ...filter,
      });
      if (response.message) {
        setMessage(response.message);
        return;
      }
      setAgents(response);
    } catch (error) {
      setAlertBoxContent({
        display: true,
        variant: "error",
        title: translate("something_went_wrong"),
        onClose: () => {
          setAlertBoxContent(null);
        },
      });
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getAgentsCourseQualifications();
  }, [pagination]);

  useEffect(() => {
    setPagination((prev) => ({ pageIndex: 1, pageSize: prev.pageSize }));
  }, [filter]);

  return (
    <Box className={styles.containerPaginationAndAgentCard}>
      <Box className={styles.wrapperAgentCourse}>
        <FilterSectionAgentCourseQualifications
          filter={filter}
          setFilter={setFilter}
        />
        <Box className={styles.containerCardsAgentsCourse}>
          {loading ? (
            <>
              {[...Array(8)].map((_, index) => (
                <AgentCardSkeleton key={index} />
              ))}
            </>
          ) : agents.result.length > 0 ? (
            <>
              {agents.result.map((agent, index) => (
                <AgentCard data={agent} key={index} />
              ))}
            </>
          ) : (
            <NoDataFound title={translate("Agent-Course")} />
          )}
        </Box>
      </Box>
      {agents?.result?.length > 0 && (
        <CustomPagination
          itemsPerPage={pagination.pageSize}
          currentPage={pagination.pageIndex}
          inputValue={inputValue}
          setInputValue={setInputValue}
          totalItems={agents.totalCount}
          onPageChange={(page) =>
            setPagination((prev) => ({ ...prev, pageIndex: page }))
          }
          onItemsPerPageChange={(items) =>
            setPagination((prev) => ({ ...prev, pageSize: items }))
          }
          isLoading={loading}
        />
      )}
    </Box>
  );
}

export default AgentCourseQualifications;
